<template>
  <v-card v-if="sprint !== undefined">
    <v-toolbar>
      <v-toolbar-title>Sprint - {{sprint.name}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <table width="100%">
        <tr>
          <th>User</th>
          <th v-for="column in columns" :key="column">{{column}}</th>
        </tr>
        <tr v-for="user in users" :key="user.id">
          <td style="padding-left: 10px;">{{user.name}}</td>
          <td v-for="column in columns" :key="column">
            <draggable
              group="draggableStories"
              :component-data="getComponentData()"
              @start="dragging = true"
              @end="dragging = false"
              @add="moveStory(user, column)"
            >
              <v-card
                color="blue-grey darken-2"
                v-for="story in storiesByColumn(column, user)"
                :key="story.id"
                :id="story.id"
                class="ma-2"
              >
                <v-card-title>
                  <span class="title font-weight-light">{{ story.title }}</span>
                </v-card-title>
                <v-card-text>
                  {{story.description}}
                </v-card-text>
              </v-card>
            </draggable>
          </td>
        </tr>
      </table>
    </v-card-text>
    <v-toolbar>
      <v-toolbar-title>Backlog</v-toolbar-title>
    </v-toolbar>
    <v-card-actions v-if="backlogStories != null">
      <draggable
        group="draggableStories"
        :component-data="getComponentData()"
        @start="dragging = true"
        @end="dragging = false"
        @add="moveStory(user, column)"
      >
        <v-card
          color="blue-grey darken-2"
          v-for="story in backlogStories"
          :key="story.id"
          :id="story.id"
          class="ma-2"
        >
          <v-card-title>
            <span class="title font-weight-light">{{ story.title }}</span>
          </v-card-title>
          <v-card-text>
            {{story.description}}
          </v-card-text>
        </v-card>
      </draggable>
    </v-card-actions>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable';
import moment from 'moment';

export default {
  data: () => ({
    columns: [
      'ToDo',
      'In progress',
      'Review',
      'Done',
    ],
    activeStoryId: String,
  }),
  components: {
    draggable,
  },
  methods: {
    moveStory(user, column) {
      const story = this.$store.getters.getStory(this.activeStoryId);
      story.done_at = null;
      if (column === 'Done') {
        story.done_at = moment().format('YYYY-MM-DD');
      }
      if (story.sprint === null) {
        story.sprint = this.sprint.id;
      }
      story.owner = user.id;
      story.status = column;
      this.$store.commit('updateStory', story);
    },
    storiesByColumn(column, user) {
      const storylist = [];
      this.stories.forEach((story) => {
        if (user.id === story.owner.id && story.status === column) {
          storylist.push(story);
        }
      });
      return storylist;
    },
    updateStoryId(val) {
      this.activeStoryId = val.item.id;
    },
    getComponentData() {
      return {
        on: {
          start: this.updateStoryId,
        },
      };
    },
  },
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    stories: {
      get() {
        return this.$store.getters.getStoriesBySprint(this.sprint.id);
      },
    },
    sprint() {
      return this.$store.getters.getActiveSprint;
    },
    backlogStories() {
      return this.$store.getters.getBacklogStories;
    },
  },
};
</script>

<style lang="scss">
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  th, td {
    width: 20%;
    height: 50px;
  }

  tr {
    min-height: 50px;
  }
</style>
